import { useEffect, useState } from 'react';
import { getInitials } from '@utils/helpers';

const GRADIENTS = [
  'from-brand-400 to-brand-600',
  'from-violet-400 to-purple-600',
  'from-emerald-400 to-teal-600',
  'from-amber-400 to-orange-600',
  'from-rose-400 to-pink-600',
  'from-cyan-400 to-blue-600',
];

const Avatar = ({ name, src, size = 'md', verified = false, className = '', shape = 'rounded' }) => {
  const [imgFailed, setImgFailed] = useState(false);

  useEffect(() => {
    setImgFailed(false);
  }, [src]);

  const sizes = {
    sm: 'h-8 w-8 text-[10px]',
    md: 'h-11 w-11 text-xs',
    lg: 'h-14 w-14 text-sm',
    xl: 'h-20 w-20 text-lg',
    '2xl': 'h-[88px] w-[88px] text-2xl',
  };

  const radius = shape === 'circle' ? 'rounded-full' : 'rounded-2xl';
  const gradientIdx = name ? name.charCodeAt(0) % GRADIENTS.length : 0;
  const showImage = Boolean(src) && !imgFailed;

  return (
    <div className={`relative inline-flex shrink-0 ${className}`}>
      {showImage ? (
        <img
          src={src}
          alt={name}
          onError={() => setImgFailed(true)}
          className={`${sizes[size] || sizes.md} ${radius} object-cover ring-2 ring-white/80 dark:ring-surface-800`}
        />
      ) : (
        <div
          className={`${sizes[size] || sizes.md} ${radius} flex items-center justify-center bg-gradient-to-br ${GRADIENTS[gradientIdx]} font-bold text-white ring-2 ring-white/80 dark:ring-surface-800 shadow-sm`}
        >
          {getInitials(name || '?')}
        </div>
      )}
    </div>
  );
};

export default Avatar;
